import { Component, DestroyRef, effect, inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
    MatTableDataSource,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
} from '@angular/material/table';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { Cdr } from 'src/app/models/centrex/cdr';
import { CdrService } from 'src/app/services/centrex/cdr.service';
import { ExtensionService } from 'src/app/services/centrex/extension.service';
import { Extension } from 'src/app/models/centrex/extension';
import { ServiceService } from 'src/app/services/centrex/service.service';
import { Service } from 'src/app/models/centrex/service';
import { OrganizationsService } from 'src/app/services/organizations.service';
import { ReactiveFormsModule } from '@angular/forms';
import { NgStyle, DatePipe } from '@angular/common';
import { MatDatepickerInputEvent, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatListItemIcon } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { InstanceService } from 'src/app/services/centrex/instance.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-cdr',
    templateUrl: './cdrs.component.html',
    styleUrls: ['./cdrs.component.scss'],
    imports: [
        FaIconComponent,
        ReactiveFormsModule,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatFormField,
        MatDateRangeInput,
        MatStartDate,
        MatEndDate,
        MatDatepickerToggle,
        MatSuffix,
        MatDateRangePicker,
        MatCellDef,
        MatCell,
        MatInput,
        MatIconButton,
        MatTooltip,
        MatIcon,
        MatListItemIcon,
        NgStyle,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        DatePipe,
        TranslateModule,
    ]
})
export class CdrsComponent {
    private readonly instanceService = inject(InstanceService);
    private destroyRef = inject(DestroyRef);

    // Icône
    public faAngleRight = faAngleRight;

    setupTimes: Date[] = [new Date(), new Date()];

    fromDate(type: string, event: MatDatepickerInputEvent<Date>) {
        this.setupTimes[0] = event.value;
        //clearDatas();
    }

    toDate(type: string, event: MatDatepickerInputEvent<Date>) {
        this.setupTimes[1] = event.value;
        if (this.setupTimes[0] && this.setupTimes[1]) this.loadDatas();
    }

    displayedColumns: string[] = ['setupTime', 'flow', 'caller', 'called', 'talker', 'error'];
    dataSource: MatTableDataSource<Cdr>;

    filtersForm: UntypedFormGroup;

    public extensions: Extension[] = [];
    public services: Service[] = [];

    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    constructor(
        private cdrService: CdrService,
        private extensionService: ExtensionService,
        private organizationsService: OrganizationsService,
        private serviceService: ServiceService,
        private dialog: MatDialog,
        private translate: TranslateService,
        private toastr: ToastrService,
        private formbuilder: UntypedFormBuilder,
        private spinner: NgxSpinnerService
    ) {
        this.filtersForm = new UntypedFormGroup({});

        effect(() => {
            if (this.instanceService.instance()) {
                this.loadDatas();
            }
        });
    }

    loadDatas() {
        this.spinner.show();

        forkJoin([this.extensionService.getExtensions(), this.serviceService.getServices(), this.cdrService.getCdrs(this.setupTimes[0], this.setupTimes[1])])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: ([extensions, services, cdrs]) => {
                    this.extensions = extensions;
                    this.services = services;

                    this.dataSource = new MatTableDataSource(cdrs);

                    let mySelf = this;
                    this.dataSource.filterPredicate = function (cdr, filter) {
                        var match: boolean = false;

                        for (let k in mySelf.filters) {
                            if (mySelf.filters[k] == null) continue;
                            switch (k) {
                                case 'flow':
                                    match ||= cdr.from?.includes(mySelf.filters[k]);
                                    match ||= cdr.to?.includes(mySelf.filters[k]);
                                    break;
                                case 'caller':
                                    match ||= cdr.callerName?.includes(mySelf.filters[k]);
                                    match ||= cdr.callerAddress?.includes(mySelf.filters[k]);
                                    break;
                                case 'called':
                                    match ||= cdr.calledName?.includes(mySelf.filters[k]);
                                    match ||= cdr.calledAddress?.includes(mySelf.filters[k]);
                                    break;
                                case 'talker':
                                    match ||= cdr.talkerName?.includes(mySelf.filters[k]);
                                    match ||= cdr.talkerAddress?.includes(mySelf.filters[k]);
                                    break;
                                case 'error':
                                    match ||= cdr.errorCode?.toString().includes(mySelf.filters[k]);
                                    match ||= cdr.errorDescription?.includes(mySelf.filters[k]);
                                    break;
                            }
                        }
                        return match;
                    };

                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;

                    this.spinner.hide();
                },
                error: () => {
                    this.spinner.hide();
                },
            });
    }

    filters = [];

    /**
     * Application du filtre dans le tableau des cdrs
     */
    applyFilters(columnName: string, target: any = null) {
        if (columnName == null) this.filters = [];
        else if (target?.value == null) this.filters[columnName] = null;
        else {
            console.log(columnName + ': ' + target?.value);
            this.filters[columnName] = target?.value;
        }

        this.dataSource.filter = columnName;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    /**
     * Réinitialise le filtre de la colonne spécifiée.
     * @param columnName Nom du contrôle du formulaire
     */
    resetColumnFilter(columnName: string): void {
        this.applyFilters(columnName);
    }

    /**
     * Réinitialise tous les filtres de colonne
     */
    resetAllColumnFilter() {
        this.applyFilters(null);
    }
}
